/**
 * Copyright (c) 2023 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { searchWidth } from 'blb-styles/constants';
import { TypeaheadSearch } from 'blb-components/AuthenticatedApp/TypeaheadSearch';
import { PipelineFilter } from './PipelineFilter';
import { PipelineSearchResult } from './PipelineSearchResult';
import { getConfig } from 'blb-utils/config';
import { css, StyleSheet } from 'aphrodite';
import { searchForLoans } from 'blb-api/loans';
import { OpsDeskFilterParams } from 'blb-constants/pipelineFilter';

export const styles = StyleSheet.create({
  searchWrapper: {
    width: searchWidth,
  },
});

export namespace OpsDeskFilter {
  export interface Props {
    filters: OpsDeskFilterParams;
    onFilterChanged: (filterParams: OpsDeskFilterParams) => void;
  }
}

export const OpsDeskFilter: React.FC<OpsDeskFilter.Props> = ({ filters, onFilterChanged }) => {
  const { autoAssignmentUI } = getConfig();

  return (
    <>
      {autoAssignmentUI && (
        <div className={css(styles.searchWrapper)}>
          <TypeaheadSearch
            ResultComponent={PipelineSearchResult}
            id="pipeline-search"
            name="Pipeline"
            onResultClick={() => {}}
            placeholder="Search for loans"
            searchFunction={searchForLoans}
          />
        </div>
      )}
      <PipelineFilter filters={filters} setFilters={onFilterChanged} />
    </>
  );
};
